const $ = jQuery;

const Slider = {
	init: function () {
		$(document).ready(function () {
			if (window.matchMedia('(max-width: 570px)').matches) {
				$('.section-single-gallery--categories').slick({
					slidesToShow: 3, // možeš prilagoditi ako treba
					slidesToScroll: 1,
					autoplay: false,
					speed: 500,
					arrows: false,
					centerMode: false,
					variableWidth: true,
					infinite: false, // OVDJE dodaj ovu opciju
				});
			}

			// section-our-team--items
			if (window.matchMedia('(max-width: 767px)').matches) {
				$('.section-our-team--items').slick({
					arrows: false,
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,

					prevArrow:
						'<div class="arrow prev-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 6L9 12L15 18" stroke="#0C331F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
					nextArrow:
						'<div class="arrow next-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="#0C331F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
					responsive: [
						{
							// breakpoint: 1024,
							// settings: {
							//   slidesToShow: 1,
							// },
						},
					],
				});
			}

			if (window.matchMedia('(max-width: 767px)').matches) {
				const waitForThumbs = setInterval(function () {
					const $thumbs = $(
						'.woocommerce-product-gallery .flex-control-nav.flex-control-thumbs'
					);

					if ($thumbs.length > 0 && !$thumbs.hasClass('slick-initialized')) {
						clearInterval(waitForThumbs); // zaustavi proveru kada se element pronađe

						$thumbs.slick({
							arrows: false,
							dots: false,
							slidesToShow: 1,
							slidesToScroll: 1,
							centerMode: true,
							prevArrow:
								'<div class="arrow prev-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 6L9 12L15 18" stroke="#0C331F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
							nextArrow:
								'<div class="arrow next-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="#0C331F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
						});
					}
				}, 200);
			}

			$('.auto-slider').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				speed: 500,
				arrows: true,
				prevArrow:
					'<div class="arrow prev-arrow"><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="29.5" transform="rotate(-180 30 30)" stroke="#161817"/><path d="M33 24L27 30L33 36" stroke="#161817" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
				nextArrow:
					'<div class="arrow next-arrow"><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="29.5" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 0 60)" stroke="#161817"/><path d="M27 24L33 30L27 36" stroke="#161817" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
				responsive: [
					{
						breakpoint: 638,
						settings: {
							arrows: false,
							slidesToShow: 1,
							slidesToScroll: 1,
							centerMode: true,
							// variableWidth: true,
						},
					},
				],
			});
			const $parentWrapper = $('.section-product-slider--box');
			const $slider = $parentWrapper.find('.slider-content');

			$slider.on(
				'init reInit beforeChange',
				function (event, slick, currentSlide, nextSlide) {
					const slideA = nextSlide ? nextSlide : currentSlide;
					let nextElement = $slider.find(`[data-slick-index="${slideA}"]`);
					let nextElement3 = nextElement.next();
					let nextElement4 = nextElement3.next();
					let nextElement1 = nextElement.prev();
					let nextElement0 = nextElement1.prev();
					if (nextSlide == 0 && (currentSlide == 1 || currentSlide == 5)) {
						nextElement = $slider.find(`[data-slick-index="${slideA}"]`);
						nextElement3 = $slider.find(`[data-slick-index="1"]`);
						nextElement4 = $slider.find(`[data-slick-index="2"]`);
						nextElement1 = $slider.find(`[data-slick-index="-1"]`);
						nextElement0 = $slider.find(`[data-slick-index="-2"]`);
					}

					if (event.type == 'init') {
						setTimeout(() => {
							$slider.slick('slickNext');
						}, 200);
					}

					$parentWrapper
						.find('.slick-slide')
						.removeClass(
							'slick-active-0 slick-active-1 slick-active-2 slick-active-3 slick-active-4'
						);

					nextElement3.addClass('slick-active-3');
					nextElement4.addClass('slick-active-4');
					nextElement1.addClass('slick-active-1');
					nextElement0.addClass('slick-active-0');
				}
			);

			$slider.on('afterChange', function (e, slick, current) {
				// pause all
				$slider.find('video').each((i, v) => v.pause());
				const video = slick.$slider
					.get(0)
					.querySelector('.slick-current video');
				video?.play();
			});
			$slider.slick({
				infinite: true,
				slidesToShow: 5,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: '0px',
				prevArrow: $parentWrapper.find('.prev'),
				nextArrow: $parentWrapper.find('.next'),
				focusOnSelect: true,
				autoplay: true,
				autoplaySpeed: 3000,
				responsive: [
					{
						breakpoint: 991,
						settings: {
							arrows: false,
							slidesToShow: 3,
							slidesToScroll: 1,
							centerMode: true,
							arrows: false,
							focusOnSelect: true,
						},
					},
				],
			});
		});
	},
};

export default Slider;
